export default "__VITE_ASSET__CxL0UkRj__"